import { render, staticRenderFns } from "./pointTaskDetail.vue?vue&type=template&id=5993862c&scoped=true"
import script from "./pointTaskDetail.vue?vue&type=script&lang=js"
export * from "./pointTaskDetail.vue?vue&type=script&lang=js"
import style0 from "./pointTaskDetail.vue?vue&type=style&index=0&id=5993862c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5993862c",
  null
  
)

export default component.exports